module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_hairmakeup_01-e9ef13a7973585a79b819bc9f997e0b2.png";